/** Bandeau (design system, Bandeau) : message posé dans la page, tant que l'état dure. */
import { useState } from 'react';
import { cx } from '../outils';
import { Bouton } from './Bouton';
import { Icone, type NomIcone } from './Icone';

export interface BandeauProps {
  statut?: 'info' | 'succes' | 'avertissement' | 'danger';
  titre?: string;
  message: string;
  icone?: NomIcone;
  action?: { libelle: string; icone?: NomIcone; onAction: () => void | Promise<void> };
  annonce?: boolean;
}

const ICONES: Record<NonNullable<BandeauProps['statut']>, NomIcone> = {
  info: 'info',
  succes: 'circle-check',
  avertissement: 'triangle-alert',
  danger: 'circle-alert',
};

export function Bandeau({
  statut = 'info',
  titre,
  message,
  icone,
  action,
  annonce = false,
}: BandeauProps) {
  const [occupe, setOccupe] = useState(false);
  return (
    <div
      className={cx('fc-bandeau', statut !== 'info' && `fc-bandeau--${statut}`)}
      role={annonce ? (statut === 'danger' ? 'alert' : 'status') : undefined}
    >
      <Icone nom={icone ?? ICONES[statut]} className="fc-bandeau__icone" />
      <p className="fc-bandeau__message">
        {titre && <strong className="fc-bandeau__titre">{titre}</strong>} {message}
      </p>
      {action && (
        <div className="fc-bandeau__actions">
          <Bouton
            taille="compacte"
            occupe={occupe}
            {...(action.icone ? { icone: action.icone } : {})}
            onClick={async () => {
              setOccupe(true);
              try {
                await action.onAction();
              } finally {
                setOccupe(false);
              }
            }}
          >
            {action.libelle}
          </Bouton>
        </div>
      )}
    </div>
  );
}
